import { uri } from '@client/core/routing/uri';
import { getLocationOrigin } from '@client/core/utils/get-location-origin';
import { ltrim } from '@client/core/utils/ltrim';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';

export class ShareLink {
  constructor(public readonly key: string, public readonly endpoint: string) {}

  /**
   * This builds the full share URL from the origin, baseURL, and key.
   */
  public toFullURL(baseURL: string): string {
    return getLocationOrigin() + uri(`${ltrim(baseURL, '/')}/${this.key}`);
  }
}

defineTransform(ShareLink, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
